import type { interactedWithPlannerAnalytics } from './actions';

export enum AiPlannerAnalyticsActionTypes {
  INTERACTED_WITH_PLANNER = '[Analytics] [AI Planner] Interacted with Wedding Planner AI',
}

export type IInteractedWithPlannerAnalytics = ReturnType<typeof interactedWithPlannerAnalytics>;
